import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { products } from "./products";

const ProductPage = lazy(() => import("./components/ProductPage"));
const LoadingSpinner = lazy(() => import("./components/LoadingSpinner")); // Lazy load spinner too

function App() {
  // Redireciona a raiz para o primeiro produto
  const firstProductSlug = products[0]?.slug || "";
  return (
    <BrowserRouter>
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          <Route
            path="/"
            element={<Navigate to={`/${firstProductSlug}`} replace />}
          />
          <Route path=":slug" element={<ProductPage />} />
          {/* Fallback para produto não encontrado já é tratado no ProductPage */}
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
